// frontend/src/components/SEO/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Kenali Enterprise | Premium Livestock Feed & Animal Nutrition",
  description = "Premium livestock feed supplements, animal nutrition, and farming solutions for farmers in Sierra Leone. Globally sourced quality products.",
  keywords = "livestock feed Sierra Leone, animal nutrition supplements, cattle feed, poultry feed, goat feed, sheep feed, livestock farming, Kenali Enterprise, premium animal feed",
  canonical = "https://kenalienterprise.com/",
  image = "https://kenalienterprise.com/logo.png",
  type = "website",
  article = false,
  author = "Kenali Enterprise",
  publishedTime = null,
  modifiedTime = null,
}) => {
  const siteName = "Kenali Enterprise";
  const fullTitle = title.includes("Kenali Enterprise")
    ? title
    : `${title} | Kenali Enterprise`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Author */}
      {author && <meta name="author" content={author} />}

      {/* Article Specific */}
      {article && (
        <>
          <meta property="og:type" content="article" />
          {publishedTime && (
            <meta property="article:published_time" content={publishedTime} />
          )}
          {modifiedTime && (
            <meta property="article:modified_time" content={modifiedTime} />
          )}
        </>
      )}

      {/* Additional Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: fullTitle,
          description: description,
          url: canonical,
          publisher: {
            "@type": "Organization",
            name: siteName,
          },
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
